<template>
  <div class="transformer-item"
       :class="{ 'has-setting': summary.hyperParams.length > 0, 'no-use-transformer': !selected }"
       @click.stop.prevent="onClickSetting">
    <div class="transformer-item-title">
      <div>{{ summary.transformerName }}</div>
    </div>
    <tooltip-icon icon="el-icon-warning" placement="bottom" class="icon error" :content="transformer.hasError"
                  v-if="transformer.hasError"></tooltip-icon>
    <font-awesome-icon class="icon setting" icon="cog" v-if="summary.hyperParams.length > 0 && selected"/>
    <!--<i class="icon delete el-icon-close" :class="{ 'disabled': !deletable }" @click.stop.prevent="onClickDelete" v-if="deletable"/>-->
    <el-checkbox class="select-checkbox" :class="{ 'has-selected': selected }" ref="selectCheckbox" v-model="selected"
                 :label="false" :checked="transformer.use" :disabled="deletable"></el-checkbox>
  </div>
</template>

<script>
import CommonUtil from '../../../../utils/common'
import {Transformer, TransformerSummary} from '../../../../defines/transformer'

export default {
  name: 'TransformItemCmp',
  components: {},
  props: {
    transformer: Transformer,
    summary: TransformerSummary,
    deletable: {type: Boolean, default: false}
  },
  data () {
    return {
      selected: false
    }
  },
  mounted () {
    this.selected = this.transformer.use
    if (CommonUtil.isNotNull(this.$refs.selectCheckbox)) {
      this.$refs.selectCheckbox.$el.querySelector('.el-checkbox__inner')
        .addEventListener('click', this.onClickCheckbox)
    }
  },
  beforeDestroy () {
    if (CommonUtil.isNotNull(this.$refs.selectCheckbox)) {
      this.$refs.selectCheckbox.$el.querySelector('.el-checkbox__inner')
        .removeEventListener('click', this.onClickCheckbox)
    }
  },
  methods: {
    onClickCheckbox (event) {
      event.stopPropagation()
      event.preventDefault()

      if (this.deletable) {
        return
      }

      this.selected = !this.selected
      this.$forceUpdate()
      if (this.selected) {
        this.$emit('selected')
      } else {
        this.$emit('deselected')
      }
    },
    onClickSetting () {
      if (this.selected) {
        if (CommonUtil.isNotEmpty(this.summary.hyperParams)) {
          return this.$emit('setting')
        }
      }
    }
  }
}

</script>

<style scoped>
  .transformer-item {
    display: flex;
    flex-direction: column;
    width: 160px;
    height: 100px;
    padding: 6px;
    border: solid 1px #c0d5ef;
    border-radius: 2px;
    position: relative;
  }

  .transformer-item:hover {
    background-color: #f1f9ff;
  }

  .transformer-item.has-setting {
    cursor: pointer;
  }

  .transformer-item.no-use-transformer {
    background-color: #ccc;
    opacity: 0.7;
  }

  .transformer-item > .transformer-item-title {
    display: flex;
    justify-content: center;
    flex-grow: 1;
    align-items: center;
    text-align: left;
    font-size: 0.92rem;
    line-height: 1.3;
    padding: 6px;
  }

  .transformer-item > .icon.setting {
    position: absolute;
    top: 6px;
    left: 6px;
    color: #888;
    font-size: 1.1rem;
  }

  .transformer-item > .icon.error {
    position: absolute;
    bottom: 9px;
    left: 70px;
    color: #d8243e;
    font-size: 1.2rem;
  }

  .transformer-item > .icon.delete {
    visibility: hidden;
    position: absolute;
    top: 2px;
    right: 2px;
    color: #2456d4;
    font-size: 1.6rem;
    cursor: pointer;
    opacity: 1.0;
  }

  .transformer-item:hover > .icon.delete,
  .transformer-item:hover > .select-checkbox {
    visibility: visible;
  }

  .transformer-item > .icon.delete:not(.disabled):hover,
  .transformer-item > .icon.error:not(.disabled):hover {
    opacity: 0.7;
  }

  .transformer-item > .select-checkbox {
    visibility: hidden;
    position: absolute;
    top: 2px;
    right: 2px;
    margin: 0;
  }


</style>



// WEBPACK FOOTER //
// src/components/model/train/transform/item.vue